// extracted by mini-css-extract-plugin
export default {"label":"_72d003da","copyLinkWrapper":"_883b2cea","trackOnSiteCta":"_bd51128f"};